import React, { useState, useEffect } from "react";
import { Card, Select, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { Layout, Row, Col, Image } from "antd";
const { Title } = Typography;
const { Option } = Select;
const { Header } = Layout;

const StudentDropdown = () => {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);

  useEffect(() => {
    const storedStudents = JSON.parse(localStorage.getItem("students"));
    if (storedStudents && storedStudents.length > 0) {
      setStudents(storedStudents);
    }
  }, []);

  const handleStudentSelect = (studentId) => {
    const selected = students.find((student) => student._id === studentId);
    localStorage.setItem("Student_Id", selected?._id);
    const typeOfUser =
    localStorage.getItem("typeOfUser") || sessionStorage.getItem("typeOfUser");
    const loginType = localStorage.getItem("loginType");
    if((typeOfUser === "existingUser" && loginType === "both")){
      navigate("/dashboard");
    }
    else{
    navigate("/personalDetails");
    }
  };

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage:
          "url(https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://fdczvxmwwjwpwbeeqcth.supabase.co/storage/v1/object/public/images/889e1b27-b887-4082-a896-b7921854ef78/722b627e-72e3-4422-80a7-aab78de2256e.png)",
        backgroundPosition: "center",
        backgroundSize: "cover",
        zIndex: -1, 
      }}
    >
      <div>
        <Header style={{ backgroundColor: "#ffb948", height: "75px" }}>
          <Row align="middle" gutter={16}>
            <Col xs={8} sm={6} md={4} lg={6}>
              <a
                href="https://sriramanavami.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  preview={false}
                  src="/favicon.ico"
                />
              </a>
            </Col>
          </Row>
        </Header>
      </div>
      <div style={{ padding: "20px", maxWidth: "450px", margin: "auto" }}>
        <Card style={{ textAlign: "center" }}>
          <Title level={3}>Select a Student</Title>
          <Select
            style={{ width: "100%", marginBottom: "20px" }}
            placeholder="Select a student"
            onChange={handleStudentSelect}
          >
            {students.map((student) => (
              <Option key={student._id} value={student._id}>
                {student.name} ({student.student_id})
              </Option>
            ))}
          </Select>
        </Card>
      </div>
    </div>
  );
};

export default StudentDropdown;
